export var getSkewCorrectedDate = function (systemClockOffset) { return new Date(Date.now() + systemClockOffset); };



//////////////////
// WEBPACK FOOTER
// ./node_modules/@aws-sdk/middleware-signing/dist-es/utils/getSkewCorrectedDate.js
// module id = 356
// module chunks = 0